<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XpdFvx/tc-custom/9781480473836.jpg?1733031584967" alt="This image is the cover for the book Afterlife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Afterlife
      </h1>
      <p class="bookDescription body article font2">
        <b>A powerful exploration of the way AIDS reshapes relationships and lives</b><br/><br/><i>Afterlife </i>is a haunting and unforgettable story of men facing loss and seeking love, movingly capturing the moment in the 1980s when the AIDS epidemic was completely devastating the American gay community. Here, National Book Award winner Paul Monette depicts three men of various economic and social backgrounds, all with one thing in common: They are widowers, in a way, and all of their lovers died of AIDS in an LA hospital within a week of one another.<br/><br/> Steven, Sonny, and Dell meet weekly to discuss how to go on with their lives despite the hanging sword of being HIV positive. One tries to find a semblance of normalcy; one rebels openly against the disease, choosing to treat his body as a temple that he can consecrate and desecrate at will; and one throws himself into fierce political activism. No matter what path each one takes, they are all searching for one thing: a way to live and love again.<br/><br/><i>Afterlife </i>finds Paul Monette at his most autobiographical, portraying men in a situation that he himself experienced, and one that he described to critical acclaim in the award-winning <i>Borrowed Time: An AIDS Memoir</i>.<br/><br/> This ebook features an illustrated biography of Paul Monette including rare images and never-before-seen documents from the Paul Monette papers of the UCLA Library Special Collections.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Monette
      </h2>
      
      <p class="authorDescription body article">Paul Monette (1945&ndash;1995) was an author, poet, and gay rights activist. Born in Massachusetts and educated at Yale University, he moved with his partner Roger Horwitz to Los Angeles in 1978 and became involved in the gay rights movement. Monette&rsquo;s writing captures the sense of heartbreak and loss at the center of the AIDS crisis. His first novel, <I>Taking Care of Mrs. Carroll</I>, was published in 1978, and he went on to write several more works of fiction, poetry, and memoir. <I>Borrowed Time: An AIDS Memoir</I>, the tender account of his partner&rsquo;s battle with the disease, earned him both PEN Center West and Lambda literary awards. In 1992, Monette won the National Book Award in Nonfiction for <I>Becoming a Man: Half a Life Story</I>, an autobiography detailing his early life and his struggle with his sexuality. Written as a classic coming-of-age story, <I>Becoming a Man</I> became a seminal coming-out story. In 1995, Monette founded the Monette-Horwitz Trust, which honors individuals and organizations working to combat homophobia. Monette died in his home in West Hollywood in 1995 of complications from AIDS.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ba1cb30